@if (isUnified) {
  <!-- Unified Code: training centres as cards with a clear CTA (criterion 28). -->
  <section *ngIf="carouselResize.data.length" class="uc-home-section" [dir]="isRtl ? 'rtl' : 'ltr'">
    <div class="container">
      <div class="uc-home-section__header">
        <h2 class="uc-home-section__title uc-display-sm" translate="home.centers"></h2>
      </div>
      <ul class="uc-card-grid">
        <li *ngFor="let item of carouselResize.data">
          <article class="uc-card uc-entity-card">
            <div class="uc-entity-card__logo">
              <img loading="lazy" [src]="mediaUrl + item.logo" alt="">
            </div>
            <h3 class="uc-card__title uc-text-lg uc-semibold">
              <a [routerLink]="['/training-center/profile', item.id]" [queryParams]="{isInstructor: false}">{{ isRtl ? item.nameAr : item.name }}</a>
            </h3>
            <p *ngIf="isRtl ? item.description : item.descriptionLang" class="uc-card__description uc-text-sm">{{ isRtl ? item.description : item.descriptionLang }}</p>
            <div class="uc-card__actions">
              <a class="btn uc-card__cta" [routerLink]="['/training-center/profile', item.id]" [queryParams]="{isInstructor: false}">
                {{ "unifiedHome.cta.viewCenter" | translate }}
                <span class="visually-hidden">: {{ isRtl ? item.nameAr : item.name }}</span>
              </a>
            </div>
          </article>
        </li>
      </ul>
    </div>
  </section>
} @else {
<section *ngIf="carouselResize.data.length">
  <div class="container py-5">
    <div class="row align-middle">
      <div class="col px-lg-0">
        <h2 class="home-titles mb-4" translate="home.centers" [class]="isRtl ? 'text-end' : 'text-start'"></h2>
        <app-custom-carousel #appCustomCarousel [content]="trainingCentersContent" [carouselResize]="carouselResize" (shareIndex)="carouselResize.currentIndex = $event" [showControls]="true" [showIndicators]="true" [distanceBetweenControlsIndicators]="true"></app-custom-carousel>
      </div>
      <div class="col d-none d-xl-flex justify-content-center">
        <img loading="lazy" class="w-75" src="assets/imgs/training-centers.svg" alt="EXAB">
      </div>
    </div>
  </div>
  <ng-template #trainingCentersContent>
    <div class="carousel-container w-100 position-relative overflow-hidden">
      <ng-container *ngFor="let slide of carouselResize.items; track i; let i = index">
        <div class="carousel-slide py-2 px-3 w-100 h-100 position-absolute" [ngStyle]="{left: 'calc('+ i +'*100%)', transform: 'translateX(-'+ carouselResize.currentIndex +'00%)'}">
          <div class="row row-cols-md-2 gy-md-3 justify-content-center">
            <div class="col" *ngFor="let item of slide">
              <div class="training-center-card bg-white position-relative d-flex flex-column align-items-center justify-content-center">
                <div class="position-absolute bg-white d-flex align-items-center justify-content-center border rounded-circle overflow-hidden">
                  <img loading="lazy" class="w-100 h-100 object-fit-cover" [src]="mediaUrl + item.logo" [alt]="isRtl ? item.nameAr : item.name">
                </div>
                <div class="position-relative">
                  <h4 class="mb-3 overflow-hidden text-center">{{isRtl ? item.nameAr : item.name}}</h4>
                  <p [dir]="isRtl ? 'rtl' : 'ltr'" class="position-relative mb-0">{{isRtl ? item.description : item.descriptionLang}}
                    <a [ngClass]="isRtl ? 'start-0' : 'end-0'" class="position-absolute bottom-0" [routerLink]="['/training-center/profile', item.id]" [queryParams]="{isInstructor: false}">
                      <span *ngIf=" item.description && item.descriptionLang">....</span>
                      <span class="text-decoration-underline" translate="home.seeMore"></span>
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
</section>
}
